import { api } from '../../libs/api'

export default {
  namespaced: true,

  state: {
    loading: false,
    index: {},
  },
  mutations: {
    setLoading: state => state.loading = true,
    setLoaded: state => state.loading = false,
    setAggregations: (state, index) => state.index = index,
  },
  getters: {
    isLoading: state => !!state.loading,
  },
  actions: {
    async reset ({ commit }) {
      commit('setLoaded')
      commit('setAggregations', {})
    },
    async fetchAggregations ({ commit, state }, { query }) {
      if (state.loading) {
        return Promise.resolve()
      }
      commit('setLoading')

      try {
        const response = await api.fetchAggregations(query)
        commit('setAggregations', response)
      } catch (e) {
        return Promise.reject(e)
      } finally {
        commit('setLoaded')
      }
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/aggregation.js